"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxInput = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
exports.CheckboxInput = (0, react_1.forwardRef)(({ className, title, defaultValues = [], options, handlerUpdate, buttonStyle = {
    width: '123px',
}, noShowButtonArea = true, buttonOption, inputType = 'checkbox', // Default to checkbox
disabled, ...props }, ref) => {
    const [selectedValues, setSelectedValues] = (0, react_1.useState)(defaultValues);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: () => {
            // Focus on the first input or another appropriate element
        },
        getValues: () => selectedValues,
        setValues: (newValues) => {
            setSelectedValues(newValues);
            handlerUpdate(newValues);
        },
    }));
    const handleInputChange = (e) => {
        const { value, checked } = e.target;
        let updatedValues;
        if (inputType === 'checkbox') {
            updatedValues = checked
                ? [...selectedValues, value]
                : selectedValues.filter(v => v !== value);
        }
        else {
            updatedValues = [value];
        }
        setSelectedValues(updatedValues);
        handlerUpdate(updatedValues);
    };
    (0, react_1.useEffect)(() => {
        if (lodash_1.default.isEqual(selectedValues, defaultValues))
            return;
        setSelectedValues(defaultValues);
    }, [defaultValues]);
    return (react_1.default.createElement("div", { className: `text-input ${className}` },
        title && react_1.default.createElement("label", { className: "title" }, title),
        react_1.default.createElement("div", { className: "choice-wrap" }, options.map(option => (react_1.default.createElement("label", { key: option.id, style: { cursor: `${!disabled ? 'pointer' : 'default'}` } },
            react_1.default.createElement("input", { type: inputType, value: option.id, checked: selectedValues.includes(option.id), onChange: handleInputChange, name: inputType === 'radio' ? title : undefined, disabled: disabled, ...props }),
            react_1.default.createElement(common_1.Button, { text: option.value, option: {
                    buttonBeforeIcon: {
                        show: true,
                        name: selectedValues.includes(option.id)
                            ? inputType === 'radio'
                                ? 'radio_checked'
                                : 'checked'
                            : inputType === 'radio'
                                ? 'radio_unchecked'
                                : 'unchecked',
                        size: 22,
                        color: Colors_1.Colors.transparent,
                    },
                } }))))),
        noShowButtonArea && buttonOption && (react_1.default.createElement("div", { style: buttonStyle },
            react_1.default.createElement(common_1.Button, { className: buttonOption.className, text: buttonOption.title, onClick: buttonOption.onClick })))));
});
